export default __webpack_public_path__ + "static/media/metaMask.76a979b5.svg";